import profileMarkup from '../markup/online__profile.js';
import auth from '../tools/storage.js';
import xhr from '../tools/xhr.js';

const SalaryTablo = document.querySelector('#salary-info');

const getSalaryInfo = () => {

  // CalendarMarkup.cleanContainer();
  // CalendarMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'POST',
    url: `crm/user/${auth.data.operatorId}/salary`,
    data: `view_last=0&token=${auth.data.token}`,
    callbackSuccess: onSuccessRequesSalary
  };
};

const onSuccessRequesSalary = (salaryRequestServer) => {
  if (salaryRequestServer.status === 200) {
    let totalSalary = (parseInt((salaryRequestServer.data.total_hours * salaryRequestServer.data.wage_on_hour), 10) + parseInt((salaryRequestServer.data.total_upsale * salaryRequestServer.data.total_upsale_cost), 10) + parseInt(salaryRequestServer.data.total_cor_puck_money, 10));

    let SalaryTabloDetalization = '<table class=\'tb_salary_detalizations\'  ><tr><td>№</td><td>Дата</td><td></td><td>Сумма</td><td>Комментарий</td></tr>';
    let arrayDetails = salaryRequestServer.data.detalization;

    for (let i = 0; i < arrayDetails.length; i++) {
      let localValue = arrayDetails[i].eus_value;
      SalaryTabloDetalization = SalaryTabloDetalization + '<tr><td>' + (i + 1) + '</td><td>' + arrayDetails[i].eus_time + '</td><td>' + localValue + '</td><td> ₽. </td><td>' + arrayDetails[i].eus_comment + '</td><tr>';
    }
    SalaryTabloDetalization = SalaryTabloDetalization + '</table>';

    SalaryTablo.innerHTML = `<table style = "color: black" class = 'table_wage_main' >
                        <tr>
                           <td><span>Имя:</span></td>
                            <td><span>${auth.data.nickname}</span></td>
                        </tr>
                        <tr>
                           <td><span>Почта:</span></td>
                            <td><span>${auth.data.email}</span></td>
                        </tr>
                         <tr>
                           <td><span>Последний вход:</span></td>
                            <td><span>${salaryRequestServer.data.open_session}</span></td>
                        </tr>

                          </table>

                        <br><br><h3  style = "color: black">Зар.плата:</h3>

                        <table style = 'color: black' class = 'table_wage_salary' > 
                        <tr>
                           <td><span>Отработанно часов:</span></td>
                            <td><span id='table_wage_hour'>${salaryRequestServer.data.total_hours}</span></td>
                            <td><span id='table_wage_hour_money'>${salaryRequestServer.data.total_hours * salaryRequestServer.data.wage_on_hour} ₽</span></td>
                        </tr> 
                        <tr>
                           <td><span>UpSale:</span></td>
                            <td><span id='table_wage_upsale'>${salaryRequestServer.data.total_upsale} </span></td>
                            <td><span id='table_wage_upsale_money'>${salaryRequestServer.data.total_upsale * salaryRequestServer.data.total_upsale_cost} ₽</span></td>
                        </tr>
                        <tr>
                        <td><span>Оформелно кор. пакетов:</span></td>
                            <td><span id='table_wage_cor_pack'>${salaryRequestServer.data.total_cor_puck} </span></td>
                            <td><span id='table_wage_cor_pack_money'>${salaryRequestServer.data.total_cor_puck_money} ₽</span></td>
                        </tr>
                        <tr>
                           <td><span>Начислено:</span></td>
                           <td></td>
                           <td><span id='table_wage_total_money'>${totalSalary} ₽</span></td>
                        </tr>
                         <tr>
                           <td><span>Последняя дата расчета:</span></td>
                            <td><span id='table_wage_time_last_payment'>${salaryRequestServer.data.last_payments}</span></td><td></td>
                        </tr>
                      
                        </table>   <br><br><h3  style = "color: black">Детализация начислений:</h3> ${SalaryTabloDetalization} `;
  }
};

export default {
  start() {
    // profileMarkup.setProfile();
    getSalaryInfo();
  },

  stop() {
    profileMarkup.clearProfile();
  }
};
